import { createActionGroup, emptyProps, props } from "@ngrx/store";

import { TErrorResponse } from "@app/core/types/response.type";

import { TCoiExportAllRequest, TCoiExportBatchRequest, TCoiExportOneRequest, TCoverageItem, TPolicy } from "../types/policy.type";

export const PolicyActions = createActionGroup({
  source: "Policy",
  events: {
    "Get Policy": props<{ policyId: string }>(),
    "Get Policy Success": props<{ policy: TPolicy }>(),
    "Get Policy Failure": props<{ errors: TErrorResponse }>(),

    "Export All COI": props<{ request: TCoiExportAllRequest }>(),
    "Export One COI": props<{ request: TCoiExportOneRequest, policyId: string }>(),
    "Export Batch COI": props<{ request: TCoiExportBatchRequest, policyId: string }>(),
    "Export COI Success": emptyProps(),
    "Export COI Failure": props<{ errors: TErrorResponse }>(),

    "Set Coverages": props<{ coverages: TCoverageItem[] | undefined }>(),
  },
});
